import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type { ReadContentVersionAnnotationsDocument } from './types'

/**
 * Reads the pin annotations for a single content version. The `content_version`
 * filter takes the version UUID; `author` is included so the feedback card can
 * show who left each comment.
 */
export const readContentVersionAnnotations = async ({
  versionUuid,
}: {
  versionUuid: string
}): Promise<ReadContentVersionAnnotationsDocument> => {
  const url = new URL('/v3/content_version_annotations', window.location.origin)

  url.search = queryString({
    filter: { content_version: versionUuid },
    include: ['author'],
  })

  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}
